import { render, staticRenderFns } from "./ClassWorkHomeWork.vue?vue&type=template&id=0728bd47&"
import script from "./ClassWorkHomeWork.vue?vue&type=script&lang=js&"
export * from "./ClassWorkHomeWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports